import React, {useEffect, useState} from 'react';
import {useTranslation, withTranslation} from "react-i18next";
import {Grid} from "@material-ui/core";
import ButtonAtm from "../../../atomic/Button/Button";
import {getAppLang} from "../../../../utils";
import { PROPERTY_PRODUCTS_ACTIVATE } from "../../../../constants/api.constants";
import axios from "axios";
import { getProperty } from '../../../../utils';
import { NETWORK_COMPETITOR } from '../../../../constants/appUrls.constants';
import {CircularProgress} from '@material-ui/core';

const NotAllowedPage = ({trialEndTitle, trialEndDesc, trialEndBtnText, isTrialEnd, productId}) => {

    const { t } = useTranslation();
    const [loadingSpinner, setLoadingSpinner] = useState(false);

    const activateProduct = () => {
        setLoadingSpinner(true);

        const params = {
            params: {
                property_id: getProperty(),
                product_id: productId
            }
        }

        axios.post(PROPERTY_PRODUCTS_ACTIVATE, params, {
            headers: {
                "Accept": "application/json",
                authToken: localStorage.getItem('auth'),
                "Content-Type": "application/json",
                "language": getAppLang(),
            }
        }).then((result) => {
            setLoadingSpinner(false)
            window.location.reload();
        }).catch(function (error) {
            console.log(error);
            setLoadingSpinner(false);
        });
    }

    const redirectProperty = () => {
        window.open("https://www.extranetwork.com/" + getAppLang() + "/contact");
    }

    return (
        <>
            {
                loadingSpinner &&
                    <CircularProgress className='circularProgress-notallowedpage' style={{color:"#d71f26", zIndex: "99"}} />
            }
            <div style={{backgroundColor: '#fdfdfd'}}>
                <Grid container className="t-center">
                    <Grid item xs={12}>
                        <img src="/assets/img/gif/lock.gif" className="lock-gif" />
                    </Grid>
                    <Grid item xs={12} className="m-auto">
                        <h1 className="mb-0">{ trialEndTitle || t('enw-not-cpa-product_title') }</h1>
                        <h3>{trialEndDesc || t('enw-not-cpa-product_desc') }</h3>
                    </Grid>
                </Grid>
                <Grid container className="t-center">
                    <Grid item xs={12} lg={6} className="m-auto">
                        <ButtonAtm
                            className="not-allowed-button bg-red"
                            buttontext={trialEndBtnText || t('btn-choose_your_content_plan') }
                            autoFocus
                            color="primary"
                            onClick={isTrialEnd ? redirectProperty : activateProduct}
                        />
                    </Grid>
                </Grid>
            </div>
        </>
    )
}


export default (withTranslation('common'))(NotAllowedPage)
